import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFetchActivePlan } from 'shared/hooks/fetchering/use-fetch-active-plan';
import { SUBSCRIPTION_EXPIRY_NOTICE } from 'modules/organizer/domain/constants';
import {
  decideSubscriptionExpiryNotice,
  formatSubscriptionExpiryMessage,
} from 'modules/organizer/domain/utils/subscription-expiry-notice';
import {
  readSubscriptionExpiryNotice,
  writeSubscriptionExpiryNotice,
} from 'modules/organizer/domain/utils/subscription-expiry-notice-storage';

export function useSubscriptionExpiryToast(): void {
  const { isAuthed, isChecked, userTournamentId } = useAuth();
  const { data: subscription, isLoading } = useFetchActivePlan();
  const navigate = useNavigate();

  // Один показ на турнир за сессию SPA. Хранит id, а не boolean, — чтобы после
  // переключения турнира проверка прошла заново.
  const handledTournamentIdRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isChecked || !isAuthed || !userTournamentId) return;
    if (isLoading) return;
    if (handledTournamentIdRef.current === userTournamentId) return;

    handledTournamentIdRef.current = userTournamentId;

    const decision = decideSubscriptionExpiryNotice({
      subscription,
      lastNotice: readSubscriptionExpiryNotice(userTournamentId),
      now: new Date(),
    });

    if (decision.kind !== 'show') return;

    toast.warning(formatSubscriptionExpiryMessage(decision.daysLeft, decision.activeTo), {
      toastId: `subscription-expiry-${userTournamentId}`,
      autoClose: SUBSCRIPTION_EXPIRY_NOTICE.autoCloseMs,
      onClick: () => navigate(Pages.SETTINGS.SUBSCRIPTION),
    });

    writeSubscriptionExpiryNotice(userTournamentId, {
      activeTo: decision.activeTo,
      shownAt: Date.now(),
    });
  }, [isChecked, isAuthed, userTournamentId, isLoading, subscription, navigate]);
}
